import {
  Cohort,
  EnrolmentType,
} from '../../../../ReduxStorage/Cohorts/CohortTypes';
import {
  CreateOrEditClassModalErrors,
  CohortStats,
  CohortsTablePageCursor,
  CohortsDataRequest,
  SelectableCohort,
} from './state';
import { Currency } from '../../../utilities/currency-list';

export const CREATE_NEW_CLASS_CLICKED = 'CREATE_NEW_CLASS_CLICKED';
export type CourseClassesCreateNewClassClickedAction = {
  type: 'CREATE_NEW_CLASS_CLICKED';
};

export const SHOW_CREATE_NEW_CLASS_MODAL = 'SHOW_CREATE_NEW_CLASS_MODAL';
export type CourseClassesShowCreateNewClassModalAction = {
  type: 'SHOW_CREATE_NEW_CLASS_MODAL';
  cohort: { title: string; coursePath: string };
  isExternalPaymentEnabled: boolean;
};

export const HIDE_CREATE_NEW_CLASS_MODAL = 'HIDE_CREATE_NEW_CLASS_MODAL';
export type CourseClassesHideCreateNewClassModalAction = {
  type: 'HIDE_CREATE_NEW_CLASS_MODAL';
};

export const UPDATE_CREATE_OR_EDIT_CLASS_MODAL_COHORT =
  'UPDATE_CREATE_OR_EDIT_CLASS_MODAL_COHORT';
export type UpdateCreateOrEditClassModalCohortAction = {
  type: 'UPDATE_CREATE_OR_EDIT_CLASS_MODAL_COHORT';
  changes: {
    title?: string;
    studentPrice?: string;
    currency?: Currency;
    iosProductId?: string;
    accessCode?: string;
  };
};

export const UPDATE_CREATE_OR_EDIT_CLASS_MODAL_ENROLMENT_TYPE =
  'UPDATE_CREATE_OR_EDIT_CLASS_MODAL_ENROLMENT_TYPE';
export type UpdateCreateOrEditClassModalEnrolmentTypeAction = {
  type: 'UPDATE_CREATE_OR_EDIT_CLASS_MODAL_ENROLMENT_TYPE';
  enrolmentType: EnrolmentType;
};

export const FETCH_COHORT_ACCESS_CODE_SUCCESS =
  'FETCH_COHORT_ACCESS_CODE_SUCCESS';
export type FetchCohortAccessCodeSuccessAction = {
  type: 'FETCH_COHORT_ACCESS_CODE_SUCCESS';
  accessCode: string;
};

export const FETCH_COHORT_ACCESS_CODE_FAILURE =
  'FETCH_COHORT_ACCESS_CODE_FAILURE';
export type FetchCohortAccessCodeFailureAction = {
  type: 'FETCH_COHORT_ACCESS_CODE_FAILURE';
};

export const SUGGEST_NEW_ACCESS_CODE_SUCCESS =
  'SUGGEST_NEW_ACCESS_CODE_SUCCESS';
export type SuggestCohortAccessCodeSuccessAction = {
  type: 'SUGGEST_NEW_ACCESS_CODE_SUCCESS';
  accessCode: string;
};

export const SUGGEST_NEW_ACCESS_CODE_FAILURE =
  'SUGGEST_NEW_ACCESS_CODE_FAILURE';
export type SuggestCohortAccessCodeFailureAction = {
  type: 'SUGGEST_NEW_ACCESS_CODE_FAILURE';
};

export interface CreateClassModalValidationFailedAction {
  error: string;
}

export const CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_FAILED =
  'CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_FAILED';
export interface CreateClassModalClassNameValidationFailedAction
  extends CreateClassModalValidationFailedAction {
  type: 'CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_FAILED';
}

export const CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_PASSED =
  'CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_PASSED';
export type CreateClassModalClassNameValidationPassedAction = {
  type: 'CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_PASSED';
};

export const CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_FAILED =
  'CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_FAILED';
export interface CreateClassModalAccessCodeValidationFailedAction
  extends CreateClassModalValidationFailedAction {
  type: 'CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_FAILED';
}

export const CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_PASSED =
  'CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_PASSED';
export type CreateClassModalAccessCodeValidationPassedAction = {
  type: 'CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_PASSED';
};

export const CREATE_CLASS_MODAL_COURSE_PRICE_VALIDATION_FAILED =
  'CREATE_CLASS_MODAL_COURSE_PRICE_VALIDATION_FAILED';
export interface CreateClassModalCoursePriceValidationFailedAction
  extends CreateClassModalValidationFailedAction {
  type: 'CREATE_CLASS_MODAL_COURSE_PRICE_VALIDATION_FAILED';
  currency: string;
  error: string;
}

export const CREATE_CLASS_MODAL_COURSE_PRICE_VALIDATION_PASSED =
  'CREATE_CLASS_MODAL_COURSE_PRICE_VALIDATION_PASSED';
export interface CreateClassModalCoursePriceValidationPassedAction {
  type: 'CREATE_CLASS_MODAL_COURSE_PRICE_VALIDATION_PASSED';
  currency: string;
}

export const CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_FAILED =
  'CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_FAILED';
export interface CreateClassModalStudentPriceValidationFailedAction
  extends CreateClassModalValidationFailedAction {
  type: 'CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_FAILED';
}

export const CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_PASSED =
  'CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_PASSED';
export type CreateClassModalStudentPriceValidationPassedAction = {
  type: 'CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_PASSED';
};

export const CREATE_NEW_COHORT_START = 'CREATE_NEW_COHORT_START';
export type CreateOrEditClassModalCreateNewCohortStartAction = {
  type: 'CREATE_NEW_COHORT_START';
};

export const CREATE_NEW_COHORT_SUCCESS = 'CREATE_NEW_COHORT_SUCCESS';
export type CreateOrEditClassModalCreateNewCohortSuccessAction = {
  type: 'CREATE_NEW_COHORT_SUCCESS';
};

export const CREATE_NEW_COHORT_FAILURE = 'CREATE_NEW_COHORT_FAILURE';
export type CreateOrEditClassModalCreateNewCohortFailureAction = {
  type: 'CREATE_NEW_COHORT_FAILURE';
  errors: CreateOrEditClassModalErrors;
};

export const EDIT_CLASS_CLICKED = 'EDIT_CLASS_CLICKED';
export type CourseClassesEditClassClickedAction = {
  type: 'EDIT_CLASS_CLICKED';
  cohortPath: string;
};

export const SHOW_EDIT_CLASS_MODAL = 'SHOW_EDIT_CLASS_MODAL';
export type CourseClassesShowEditClassModalAction = {
  type: 'SHOW_EDIT_CLASS_MODAL';
  cohort: Cohort;
  defaultCohort: Cohort;
  isExternalPaymentEnabled: boolean;
  accessCode?: string;
};

export const HIDE_EDIT_CLASS_MODAL = 'HIDE_EDIT_CLASS_MODAL';
export type CourseClassesHideEditClassModalAction = {
  type: 'HIDE_EDIT_CLASS_MODAL';
};

export const SAVE_COHORT_START = 'SAVE_COHORT_START';
export type CreateOrEditClassModalSaveCohortStartAction = {
  type: 'SAVE_COHORT_START';
};

export const SAVE_COHORT_SUCCESS = 'SAVE_COHORT_SUCCESS';
export type CreateOrEditClassModalSaveCohortSuccessAction = {
  type: 'SAVE_COHORT_SUCCESS';
  cohortPath: string;
};

export const SAVE_COHORT_FAILURE = 'SAVE_COHORT_FAILURE';
export type CreateOrEditClassModalSaveCohortFailureAction = {
  type: 'SAVE_COHORT_FAILURE';
  errors: CreateOrEditClassModalErrors;
};

export const FETCH_COURSE_CLASSES_SUCCESS = 'FETCH_COURSE_CLASSES_SUCCESS';
export type FetchCourseClassesSuccessAction = {
  type: 'FETCH_COURSE_CLASSES_SUCCESS';
  cohorts: CohortStats[];
  total: number | 0;
  previousPage: CohortsTablePageCursor | null;
  nextPage: CohortsTablePageCursor | null;
  lastRequest: CohortsDataRequest | null;
  selectableCohorts: SelectableCohort[];
};

export const FETCH_COURSE_CLASSES_FAILURE = 'FETCH_COURSE_CLASSES_FAILURE';
export type FetchCourseClassesFailureAction = {
  type: 'FETCH_COURSE_CLASSES_FAILURE';
  error: string;
};

export const SET_COURSE_DEFAULT_COHORT = 'SET_COURSE_DEFAULT_COHORT';
export type SetCourseDefaultCohortAction = {
  type: 'SET_COURSE_DEFAULT_COHORT';
  coursePath: string;
  defaultCohortPath: string;
};

export const SYNC_COHORTS = 'SYNC_COHORTS';
export type SyncCohortsAction = {
  type: 'SYNC_COHORTS';
  selectableCohorts: SelectableCohort[];
  coursePath: string;
  defaultCohortPath: string;
};

export const ADD_OTHER_STUDENT_PRICE = 'ADD_OTHER_STUDENT_PRICE';
export type CreateOrEditClassModalAddOtherStudentPriceAction = {
  type: 'ADD_OTHER_STUDENT_PRICE';
  cohort: Cohort;
};

export type CourseAdminCourseClassesAction =
  | CourseClassesCreateNewClassClickedAction
  | CourseClassesShowCreateNewClassModalAction
  | CourseClassesEditClassClickedAction
  | CourseClassesShowEditClassModalAction
  | CourseClassesHideEditClassModalAction
  | CourseClassesHideCreateNewClassModalAction
  | UpdateCreateOrEditClassModalCohortAction
  | UpdateCreateOrEditClassModalEnrolmentTypeAction
  | CreateClassModalClassNameValidationFailedAction
  | CreateClassModalClassNameValidationPassedAction
  | CreateClassModalAccessCodeValidationFailedAction
  | CreateClassModalAccessCodeValidationPassedAction
  | CreateClassModalStudentPriceValidationFailedAction
  | CreateClassModalStudentPriceValidationPassedAction
  | FetchCohortAccessCodeSuccessAction
  | FetchCohortAccessCodeFailureAction
  | SuggestCohortAccessCodeSuccessAction
  | SuggestCohortAccessCodeFailureAction
  | CreateOrEditClassModalCreateNewCohortStartAction
  | CreateOrEditClassModalCreateNewCohortSuccessAction
  | CreateOrEditClassModalCreateNewCohortFailureAction
  | CreateOrEditClassModalSaveCohortStartAction
  | CreateOrEditClassModalSaveCohortSuccessAction
  | CreateOrEditClassModalSaveCohortFailureAction
  | FetchCourseClassesSuccessAction
  | FetchCourseClassesFailureAction
  | SetCourseDefaultCohortAction
  | SyncCohortsAction
  | CreateOrEditClassModalAddOtherStudentPriceAction
  | CreateClassModalCoursePriceValidationFailedAction
  | CreateClassModalCoursePriceValidationPassedAction;
